import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { OneTimePaymentActions, RecurringPaymentActions } from '../payment/actions';
import {
  DonationFlowStripeActions,
  DonationFlowHelpersActions,
} from '../donation-flow/actions';
import { normalizePaymentError } from '../../components/shared/payment-errors/payment-error-normalizer';

@Injectable()
export class PaymentAlertEffects {
  private readonly actions$ = inject(Actions);
  private readonly translate = inject(TranslateService);

  showPaymentError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          OneTimePaymentActions.confirmFailed,
          RecurringPaymentActions.confirmFailed,
          DonationFlowStripeActions.sendCustomerFailure,
          DonationFlowStripeActions.sendSetupIntentFailure,
          DonationFlowStripeActions.sendInvoiceFailure,
          DonationFlowStripeActions.sendSubscriptionFailure,
          DonationFlowHelpersActions.confirmInvoicePaymentFailure,
          DonationFlowHelpersActions.retrieveSubscriptionFailure
        ),
        tap((action: any) => {
          const normalized = normalizePaymentError(action.error ?? action.message);

          const translatedMessage = this.translate.instant(normalized.messageKey);
          const translatedTitle = this.translate.instant(normalized.titleKey);

          const message =
            translatedMessage !== normalized.messageKey
              ? translatedMessage
              : normalized.fallbackMessage;

          Swal.fire({
            icon: normalized.severity,
            title:
              translatedTitle !== normalized.titleKey
                ? translatedTitle
                : 'Payment error',
            text: message,
            confirmButtonText: this.translate.instant('COMMON.OK'),
          });
        })
      ),
    { dispatch: false }
  );
}
